<template>
  <div>
    <fk-header />
    <router-view></router-view>
    <fk-footer />
  </div>
</template>

<script>
import FkFooter from "@/components/Footer.vue";
import FkHeader from "@/components/Header.vue";
import "element-ui/lib/theme-chalk/display.css";
export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    FkHeader,
    FkFooter,
  },
};
</script>

<style lang="less">
.banner {
  width: 100%;
  margin-top: 70px;
}
</style>
